var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 15,
    viewBox: "0 0 29 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.38336C0.447715 6.38336 0 6.83108 0 7.38336C0 7.93565 0.447715 8.38336 1 8.38336V6.38336ZM27.9904 8.09047C28.381 7.69994 28.381 7.06678 27.9904 6.67626L21.6265 0.312294C21.236 -0.0782304 20.6028 -0.0782304 20.2123 0.312294C19.8217 0.702818 19.8217 1.33598 20.2123 1.72651L25.8691 7.38336L20.2123 13.0402C19.8217 13.4307 19.8217 14.0639 20.2123 14.4544C20.6028 14.845 21.236 14.845 21.6265 14.4544L27.9904 8.09047ZM1 8.38336H27.2833V6.38336H1V8.38336Z",
    fill: "#0057B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5738648c98e8a9c236b065a8c8b6ef7a.svg";
export { ForwardRef as ReactComponent };